/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 22nd 2022, 9:10:03 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import TextField from "@mui/material/TextField";
import { OSDropDown } from "./OSDropDown";

type Value = string | number | boolean;

interface ValueSelectorProps {
  chosenValue: Value;
  choices?: { value: string; label: string }[];
  onChangeValue: (value: Value) => void;
  label?: string;
}

/**
 *
 * Component that allows the user to select a value from a list of choices or enter a custom value if choices are not provided.
 *
 */
export const ValueSelector = ({ choices, chosenValue, label, onChangeValue }: ValueSelectorProps) => {
  return Boolean(choices?.length) ? (
    <OSDropDown
      options={choices.reduce((previous, current) => ({ ...previous, [current.value]: current.label }), {})}
      value={chosenValue as string}
      onChangeCallBack={onChangeValue}
      label={label}
      labelId="field-value-label"
      fullWidth
    />
  ) : (
    <TextField label={label} defaultValue={chosenValue} onChange={(e) => onChangeValue(e.target.value)} fullWidth />
  );
};
